<template>
  <div class="nx-toolbar-site-selector">
    <v-autocomplete class="media-select-autocomplete mr-2"
                    dark
                    flat
                    ref="select"
                    auto-select-first
                    return-object
                    item-text="name"
                    item-value="id"
                    :menu-props="{ closeOnContentClick: true }"
                    :value="siteId"
                    :items="allowedSites"
                    :filter="normalizedSelectFilter"
    >
      <template #item="{ item }">
        <v-list-tile
          @click="navigateToSite(item)"
          class="nx-toolbar-site-selector__tile"
          :class="{ 'primary--text': item.id === siteId }"
        >
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.name }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="features.SHOW_BUTTON_OPEN_SITE_IN_NEW_TAB">
            <v-btn icon @click.stop="openSiteInNewTab(item)"
                   color="primary--text" :title="$t('message.editor.preview.openNewTab')">
              <v-icon>open_in_new</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </template>

    </v-autocomplete>
  </div>
</template>
<script>
import normalizedSelectFilter from '@/utils/normalized-select-filter';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-toolbar-site-selector',
  props: {
    allowedSites: Array,
    currentSiteId: Number,
  },
  data() {
    return {
      siteId: this.currentSiteId,
    };
  },
  computed: {
    ...mapGetters(['features']),
  },
  methods: {
    normalizedSelectFilter,
    openSiteInNewTab({ idAlias }) {
      const { href } = this.$router.resolve({
        name: 'default',
        params: { site: idAlias },
      });
      window.open(href, '_blank');
    },
    navigateToSite({ id, idAlias }) {
      if (this.features.RELOAD_PAGE_WHEN_CHANGING_SITE) {
        const { href } = this.$router.resolve({
          name: 'default',
          params: { site: idAlias },
        });
        window.location.href = href;
      } else {
        this.siteId = id;
        this.$router.push({
          name: 'default',
          params: { site: idAlias },
        });
      }
    },
  },
  watch: {
    currentSiteId: {
      handler(value) {
        this.siteId = value;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="stylus">
.nx-toolbar-site-selector {
  max-width: 50vw;

  .v-text-field {
    padding-top: 9px;
  }

  .v-text-field > .v-input__control {
    height: 100%;
  }

  .v-text-field > .v-input__control > .v-input__slot:before,
  .v-text-field > .v-input__control > .v-input__slot:after {
    border-style: none;
  }
  .media-select-autocomplete {
    input {
      width: 250px
      cursor: pointer;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 14px;
      text-align: right;
      user-select: none;
    }

    .v-input__append-inner {
      cursor: pointer;
    }
  }
}

.nx-toolbar-site-selector__tile {
  .v-list__tile__action {
    opacity: 0;
    transform: translateX(10px);
    transition: opacity linear 0.2s, transform linear 0.2s;
  }

  &:hover {
    .v-list__tile__action {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
</style>
